
import React from 'react';
import { SocialShareButtons } from '@/components/blog/public/SocialShareButtons';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface BlogPostContentProps {
  title: string;
  excerpt?: string;
  content: string;
  featuredImage?: string;
  currentUrl: string;
}

export const BlogPostContent = ({
  title,
  excerpt,
  content,
  featuredImage,
  currentUrl,
}: BlogPostContentProps) => {
  return (
    <Card className="glass-card overflow-hidden">
      {featuredImage && (
        <div className="w-full h-64 overflow-hidden">
          <img 
            src={featuredImage} 
            alt={title} 
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <CardHeader>
        <CardTitle className="text-3xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {excerpt && (
          <div className="mb-6 text-lg font-medium text-muted-foreground">
            {excerpt}
          </div>
        )}
        
        <div className="mb-6">
          <SocialShareButtons 
            title={title} 
            url={currentUrl}
            description={excerpt || ''}
            image={featuredImage || ''}
          />
        </div>
        
        <div className="prose prose-sm md:prose-base lg:prose-lg max-w-none dark:prose-invert">
          {content ? (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <p>No content available.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
